export enum MainSearchActionType {
  CHANGE_PAGE = "CHANGE_PAGE",
  CHANGE_PAGE_SIZE = "CHANGE_PAGE_SIZE",

  SET_SEARCH_QUERY = "SET_SEARCH_QUERY",
  SET_SUGGESTIONS_QUERY = "SET_SUGGESTIONS_QUERY",

  SET_SEARCH_RESULTS_COUNT = "SET_SEARCH_RESULTS_COUNT",
  SET_SUGGESTIONS_RESULTS_COUNT = "SET_SUGGESTIONS_RESULTS_COUNT",

  SUBMIT_SEARCH = "SUBMIT_SEARCH",
  SUBMIT_SUGGESTIONS = "SUBMIT_SUGGESTIONS",

  RESET_SEARCH_QUERY = "RESET_SEARCH_QUERY",
  RESET_SUGGESTIONS_QUERY = "RESET_SUGGESTIONS_QUERY",

  FETCH_SEARCH = "FETCH_SEARCH",
  FETCH_SUGGESTIONS = "FETCH_SUGGESTIONS",

  FETCH_SEARCH_START = "FETCH_SEARCH_START",
  FETCH_SUGGESTIONS_START = "FETCH_SUGGESTIONS_START",

  FETCH_SEARCH_SUCCESS = "FETCH_SEARCH_SUCCESS",
  FETCH_SUGGESTIONS_SUCCESS = "FETCH_SUGGESTIONS_SUCCESS",

  FETCH_SEARCH_FAIL = "FETCH_SEARCH_FAIL",
  FETCH_SUGGESTIONS_FAIL = "FETCH_SUGGESTIONS_FAIL",

  CLEAR_SEARCH_RESULTS = "CLEAR_SEARCH_RESULTS",
  CLEAR_SUGGESTIONS_RESULTS = "CLEAR_SUGGESTIONS_RESULTS"
}

export const PAGE_SIZE_OPTIONS = [12, 24, 36, 48];
export const DEFAULT_PAGE_SIZE_MAIN_SEARCH_RESULTS = PAGE_SIZE_OPTIONS[0];
// export const DEFAULT_PAGE_SIZE_MATERIAL_SEARCH = PAGE_SIZE_OPTIONS[1]; // TODO:
